import {STORY_PAGE_EXIT_FRAMES,storyPageExitProgress} from '../../../../src/lib/templates/story-page-transition';
export type SourcePageRow={groupId:string;order:number;from:number;to:number;baseTop:number;height:number;progressStartFrame?:number};
export type SourcePageTransition={groupId:string;from:number;previousBottom:number;progressStartFrame?:number};
/** Only positively identified consecutive pages in the same source scene, never arbitrary caption cuts. */
export function sourcePageTransitions(rows:readonly SourcePageRow[]):SourcePageTransition[]{
 const groups=new Map<string,SourcePageRow[]>();
 for(const row of rows){if(!/^story-caption:\d+:page:\d+$/.test(row.groupId))continue;const group=groups.get(row.groupId)??[];group.push(row);groups.set(row.groupId,group);}
 const result:SourcePageTransition[]=[];
 for(const [id,current] of groups){
  const match=/^(story-caption:\d+:page:)(\d+)$/.exec(id)!;
  const previous=groups.get(match[1]+(Number(match[2])-1));if(!previous)continue;
  const from=Math.min(...current.map(r=>r.from));
  const progressStartFrame=current[0]!.progressStartFrame;
  // A page must have one explicit source clock. Mixed or malformed metadata
  // cannot establish an original transition. Older documents retain their clock.
  if(current.some(r=>r.progressStartFrame!==progressStartFrame)
    || (progressStartFrame!==undefined&&!Number.isFinite(progressStartFrame)))continue;
  // Overlapping/reordered pages and edited alignment cannot be read as original page layout.
  if(previous.some(r=>r.to>from)||Math.min(...previous.map(r=>r.from))>=from)continue;
  const base=previous[0]!.baseTop;
  if([...previous,...current].some(r=>Math.abs(r.baseTop-base)>1e-6))continue;
  const physical=new Map<number,number>();
  for(const row of previous)physical.set(row.order,Math.max(physical.get(row.order)??0,row.height));
  result.push({groupId:id,from,previousBottom:base+[...physical.values()].reduce((a,b)=>a+b,0),
    ...(progressStartFrame!==undefined?{progressStartFrame}:{})});
 }
 return result.sort((a,b)=>a.from-b.from);
}
export function sourcePageSampleFrames(transitions:readonly SourcePageTransition[]):number[]{
 return transitions.flatMap(t=>[Math.ceil(t.from),...Array.from({length:STORY_PAGE_EXIT_FRAMES+1},(_,f)=>Math.ceil(t.progressStartFrame??t.from)+f)]);
}
/** Clamp to the pinned floor after interpolation; clamping either endpoint first changes the curve. */
export function sourcePageCardBottom(transitions:readonly SourcePageTransition[],frame:number,currentBottom:number,activeGroups:ReadonlySet<string>,minimum:number,gap:number):number{
 if(activeGroups.size!==1)return Math.max(minimum,currentBottom+gap);
 const transition=transitions.find(t=>activeGroups.has(t.groupId)&&frame>=t.from&&frame<(t.progressStartFrame??t.from)+STORY_PAGE_EXIT_FRAMES);
 const progress=transition?storyPageExitProgress(frame-(transition.progressStartFrame??transition.from),true):1;
 const bottom=transition?transition.previousBottom+(currentBottom-transition.previousBottom)*progress:currentBottom;
 return Math.max(minimum,bottom+gap);
}
